class AuthService {
  constructor() {
    this.sessionKey = 'cover_auth_session';
  }

  getSession() {
    try { return JSON.parse(localStorage.getItem(this.sessionKey) || 'null'); } catch { return null; }
  }
  setSession(session) {
    localStorage.setItem(this.sessionKey, JSON.stringify(session));
  }
  clearSession() {
    localStorage.removeItem(this.sessionKey);
  }

  async signup(email, password) {
    const r = await fetch('/api/supabase-auth?action=signup', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, password }) });
    const data = await r.json();
    if (!r.ok) throw new Error(data.error?.message || '가입 실패');
    return data;
  }

  async signin(email, password) {
    const r = await fetch('/api/supabase-auth?action=signin', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, password }) });
    const data = await r.json();
    if (!r.ok) throw new Error(data.error_description || data.error?.message || '로그인 실패');
    this.setSession({ email, access_token: data.access_token, refresh_token: data.refresh_token, user: data.user });
    return data;
  }

  async signout() {
    await fetch('/api/supabase-auth?action=signout');
    this.clearSession();
  }

  async oauthStart(provider) {
    const r = await fetch(`/api/supabase-auth?action=oauthStart&provider=${encodeURIComponent(provider)}&redirect_to=${encodeURIComponent(window.location.origin)}`);
    const data = await r.json();
    if (!r.ok || !data.url) throw new Error('OAuth 시작 실패');
    window.location.href = data.url;
  }

  async recover(email) {
    const r = await fetch('/api/supabase-auth?action=recover', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) });
    if (!r.ok) throw new Error('비밀번호 재설정 메일 전송 실패');
    return true;
  }
}

const authService = new AuthService();
export default authService;


